export default __webpack_public_path__ + "static/media/icon-box-open-solid.fa461432.svg";